import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import { makeGraphQLRequest } from "..";

// Agent uses Lambda authorization for workspace validation
// All requests go through the Lambda authorizer which checks workspace membership

const getAgent = async (id) =>
  makeGraphQLRequest(
    graphqlOperation(queries.getAgent, { id })
  );

const getBaseAgentsByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.agentsByWorkspace, {
      workspaceID,
      limit: 500,
      filter: {
        ephemeralAgent: {
          ne: true,
        },
      },
    })
  );

const createAgent = async (object, userId = null) => {
  const input = { ...object };
  if (userId) {
    input.createdBy = userId;
    input.updatedBy = userId;
  }
  return makeGraphQLRequest(
    graphqlOperation(mutations.createAgent, { input })
  );
};

const updateAgent = async (id, args, userId = null) => {
  // First, fetch the current version of the agent
  const getAgentResult = await makeGraphQLRequest(
    graphqlOperation(queries.getAgent, { id })
  );
  const currentAgent = getAgentResult.data.getAgent;

  // Prepare the update input
  const updateInput = { id };
  args.forEach((arg) => {
    updateInput[arg.property] = arg.value;
  });

  // Include the version number to ensure optimistic locking
  updateInput._version = currentAgent._version;

  // Add updatedBy if userId provided
  if (userId) {
    updateInput.updatedBy = userId;
  }

  return makeGraphQLRequest(
    graphqlOperation(mutations.updateAgent, { input: updateInput })
  );
};

const deleteAgent = async (id) => {
  // First, fetch the current version of the agent
  const getAgentResult = await makeGraphQLRequest(
    graphqlOperation(queries.getAgent, { id })
  );
  const currentAgent = getAgentResult.data.getAgent;

  return makeGraphQLRequest(
    graphqlOperation(mutations.deleteAgent, {
      input: {
        id,
        _version: currentAgent._version,
      },
    })
  );
};

const prepareAgentForDuplication = (newAgent) => {
  delete newAgent.id;
  delete newAgent.createdAt;
  delete newAgent.updatedAt;
  delete newAgent._version;
  delete newAgent._deleted;
  delete newAgent._lastChangedAt;
  return newAgent;
};

export default {
  createAgent,
  updateAgent,
  deleteAgent,
  getAgent,
  getBaseAgentsByWorkspaceID,
  prepareAgentForDuplication,
};
